import React from 'react';
import './style.css';
import ProfilePicture from "profile-picture";
import "profile-picture/build/ProfilePicture.css";
import {Button, FormControl} from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import html2canvas  from 'html2canvas';
import jsPDF from 'jspdf';
import Header from '../header'

import {Fab} from '@material-ui/core';

export default class Resulat1 extends React.Component{
    
      createPDF(){
        const input = document.getElementById("cv");
        html2canvas(input)
          .then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            pdf.addImage(imgData, 'PNG', 0, 0);
            pdf.save("Your_CV.pdf");  
          })
        ;

      }
   
      
render(){
    const styles = theme => ({
        multilineColor:{
            color:'white',
            backgroundColor:"black"
        }
    });
    
return (

    <div style={{backgroundColor:"whitesmoke"}}>
        <Header/>

<div  className="container" id="test" style={{width:"860px",borderStyle:"double" ,marginTop:"40px",height:"1250px", backgroundColor:"white"}}>
    <div className="wrapper" id="cv" style={{width:"860px"}}>

    <nav id="sidebar" >
        <div class="sidebar-header">
       <img src={this.props.location.data[0]} style={{marginLeft:"50px",marginTop:"30px",borderRadius:"10px"}}/>

        </div>
<br/>
        <ul class="list-unstyled components" style={{ marginLeft:"18px",color:"white",marginTop:"25px"}}>
            <h4 style={{color:"white"}}>DONNEES PERSONNELLES</h4>
            <p style={{color:"white",fontWeight:"bold"}}>Nom et prenom:</p>
<p style={{color:"white",marginTop:"-15px"}}>{this.props.location.data[0]}</p>
                <p style={{color:"white",fontWeight:"bold"}}>Adresse:</p>
                <p style={{color:"white",marginTop:"-15px"}}>{this.props.location.data[1]}</p>

                <p style={{color:"white",fontWeight:"bold"}}>Numero de telephone:</p>
                <p style={{color:"white",marginTop:"-15px"}}>{this.props.location.data[2]}</p>

                 <p style={{color:"white",fontWeight:"bold"}}>Adresse mail:</p>
                 <p style={{color:"white",marginTop:"-15px"}}>{this.props.location.data[3]}</p>

                 <p style={{color:"white",fontWeight:"bold"}}>Date de naissance:</p>
                 <p style={{color:"white",marginTop:"-15px"}}>{this.props.location.data[4]}</p>

                 <p style={{color:"white",fontWeight:"bold"}}>Linkdink:</p>
                 <p style={{color:"white",marginTop:"-15px"}}>{this.props.location.data[5]}</p>

                <hr class="solid"/>
                <div>

                </div>
        </ul>
    </nav>
<div id="content_">
    <nav >
        <div >
        
        <h1 >{this.props.location.data[6]}</h1>

                <br/><br/>
                <p >{this.props.location.data[7]}</p>

                <br/>
                <hr class="solid"/>
                <br/>
                <div className="enseignement" id="e">
                <div style={{display:"flex"}}>
                <Icon.AwardFill size={30}/>&nbsp;<h3 class="titre">  Enseignement</h3>
                </div>
                <div style={{display:"flex"}} id="e_">
                <p style={{fontSize:"16px"}}>{this.props.location.data[10]}-{this.props.location.data[11]}</p>&nbsp;&nbsp;
                <p style={{fontWeight:"bold"}}>{this.props.location.data[8]}</p><br/>
                <p style={{color:"blue"}}>{this.props.location.data[9]}</p>

                </div>

               <br/>
                  
                </div>
                


                <br/>
                <hr class="solid"/>
                <br/>
                <div className="exp" id="exp">
                <div style={{display:"flex"}}>
                <Icon.Basket2Fill size={30}/>&nbsp;<h3 class="titre">Experience</h3>
                </div>
                <div style={{display:"flex"}}>
                <p style={{fontSize:"16px"}}>{this.props.location.data[14]}-{this.props.location.data[15]}</p>
                <p style={{fontWeight:"bold"}}>{this.props.location.data[12]}</p><br/>
                <p style={{fontWeight:"bold"}}>{this.props.location.data[13]}</p>

                </div>

             
                <br/>
                </div>

                <br/>
                <hr class="solid"/>
                <br/>
                <div className="competence" id="comp">
                <div style={{display:"flex"}}>
                <Icon.Mouse3 size={30}/>&nbsp;
                <h3 class="titre">   Competence</h3>
                </div>
                <div style={{display:"flex"}}>
                <p style={{color:"blue"}}>{this.props.location.data[17]}</p>

                <p style={{fontWeight:"bold"}}>{this.props.location.data[16]}</p>

                </div>
                <br/>

                </div>

        </div>
    </nav>
</div>
        </div> 


</div>
<Fab variant="extended" onClick={this.createPDF}  id="pdf">
  Telecharge?
  <Icon.Download  />
</Fab>
    </div>
)
}
}